import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, hasMany, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;
let InvoiceproductTaxModel = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('number'), _dec4 = attr('boolean'), _dec5 = attr('number'), _dec6 = attr('boolean'), _dec7 = attr('boolean'), _dec8 = attr('boolean'), _dec9 = attr('boolean'), _dec0 = attr('string'), _dec1 = attr('string'), _dec10 = attr('number'), _dec11 = attr('boolean'), _dec12 = attr('number'), _dec13 = attr('boolean'), _dec14 = attr('boolean'), _dec15 = hasMany('invoiceproduct_tax', {
  inverse: null,
  async: false
}), _dec16 = belongsTo('user_tax', {
  inverse: null,
  async: false
}), _dec17 = attr('boolean', {
  defaultValue: false
}), _class = class InvoiceproductTaxModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "rate", _descriptor2, this);
    _initializerDefineProperty(this, "rank", _descriptor3, this);
    _initializerDefineProperty(this, "editable", _descriptor4, this);
    _initializerDefineProperty(this, "bind", _descriptor5, this);
    _initializerDefineProperty(this, "is_iva", _descriptor6, this);
    _initializerDefineProperty(this, "is_rivalsa", _descriptor7, this);
    _initializerDefineProperty(this, "is_ritenuta", _descriptor8, this);
    _initializerDefineProperty(this, "is_bollo", _descriptor9, this);
    _initializerDefineProperty(this, "natura", _descriptor0, this);
    _initializerDefineProperty(this, "type_rivalsa", _descriptor1, this);
    _initializerDefineProperty(this, "tot_bollo", _descriptor10, this);
    _initializerDefineProperty(this, "bollo_virtuale", _descriptor11, this);
    _initializerDefineProperty(this, "gt", _descriptor12, this);
    _initializerDefineProperty(this, "sum", _descriptor13, this);
    _initializerDefineProperty(this, "is_active", _descriptor14, this);
    _initializerDefineProperty(this, "cumulable_invoiceproduct_taxes", _descriptor15, this);
    _initializerDefineProperty(this, "user_tax_ref", _descriptor16, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor17, this);
  }
  get is_disactive() {
    return !this.is_active;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "rate", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "rank", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "editable", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "bind", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "is_iva", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "is_rivalsa", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "is_ritenuta", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "is_bollo", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "natura", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "type_rivalsa", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "tot_bollo", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "bollo_virtuale", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "gt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "sum", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "is_active", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "cumulable_invoiceproduct_taxes", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "user_tax_ref", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { InvoiceproductTaxModel as default };
//# sourceMappingURL=invoiceproduct-tax.js.map
